export const selectReducer = (state) => state.header;

export const selectHeaderTitle = (state) =>
  selectReducer(state) ? selectReducer(state).get('header').title : '';
